module.exports = __webpack_public_path__ + "static/media/icon-Diners.a274c60f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-Diners.svg
// module id = 2901
// module chunks = 0